/* eslint-disable camelcase */
import { BufferAttribute } from '@app/engine/rendering/buffer-attribute';
import { WebGlProgramHelper } from '@app/engine/rendering/webgl-program';
export class CustomMesh {
    id = 0;
    isLoaded_ = false;
    program_;
    vao_;
    vertices_;
    indices_;
    mvMatrix_;
    gl_;
    sortedIndices = [];
    NUM_BUCKETS = 100; // Adjust based on your needs
    buffers_ = {
        vertCount: 0,
        combinedBuf: null,
        vertPosBuf: null,
        vertNormBuf: null,
        vertIndexBuf: null,
    };
    attribs_ = {
        a_position: new BufferAttribute({
            location: 0,
            vertices: 3,
            offset: 0,
        }),
    };
    uniforms_ = {
        u_pMatrix: null,
        u_camMatrix: null,
        u_mvMatrix: null,
    };
    init(gl) {
        this.gl_ = gl;
        this.program_ = new WebGlProgramHelper(this.gl_, this.shaders_.vert, this.shaders_.frag, this.attribs_, this.uniforms_).program;
        this.initGeometry_();
        this.initBuffers_();
        this.initVao_();
        this.isLoaded_ = true;
    }
    initBuffers_() {
        const gl = this.gl_;
        this.buffers_.vertCount = this.indices_.length;
        this.buffers_.vertPosBuf = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffers_.vertPosBuf);
        gl.bufferData(gl.ARRAY_BUFFER, this.vertices_, gl.STATIC_DRAW);
        this.buffers_.vertIndexBuf = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffers_.vertIndexBuf);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices_, gl.STATIC_DRAW);
    }
    initVao_() {
        const gl = this.gl_;
        this.vao_ = gl.createVertexArray();
        gl.bindVertexArray(this.vao_);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffers_.vertPosBuf);
        gl.enableVertexAttribArray(this.attribs_.a_position.location);
        gl.vertexAttribPointer(this.attribs_.a_position.location, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffers_.vertIndexBuf);
        gl.bindVertexArray(null);
    }
}
